import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-evaluator-esig-result',
  templateUrl: './evaluator-esig-result.component.html',
  styleUrls: ['./evaluator-esig-result.component.scss']
})
export class EvaluatorEsigResultComponent implements OnInit {
  avatarUrl = "https://optimalw.com/wp-content/uploads/2015/10/sample-avatar.jpg"
  constructor() { }

  ngOnInit(): void {
  }

}
